import { Action } from 'redux';
import {
  UPDATE_PROJECT_NAME,
  UPDATE_RUNTIME_INFO,
  UPDATE_FRAMEWORK,
  UPDATE_PARAMETERS,
  UPDATE_ENV,
  UPDATE_MODE,
  UPDATE_RUNS_ON,
  UPDATE_CONCURRENCY,
  TOOGLE_FAILURE,
  UPDATE_FAILURE_COUNT,
  UPDATE_JOB_LABEL,
  UPDATE_TEST_DISCOVERY_RESULT,
  GET_USER_YAML,
  ENABLE_TUNNEL,
  RESET_HYPEREXECUTE_YAML,
  UPDATE_HYP_YAML,
  REMOVE_HYP_KEY_YAML,
  UPDATE_YAML_COMPOSER,
} from '../actions/hyperexecuteyaml';
import cloneDeep from 'lodash/cloneDeep';

const initialState: any = cloneDeep(
  JSON.parse(localStorage.getItem('hypExYaml') || '{}')
);

export default function hyperexecuteYaml(
  state = initialState,
  action: Action<string>
) {
  const { type, payload = {} }: any = action;
  switch (type) {
    case GET_USER_YAML:
      return cloneDeep(payload);
    case UPDATE_PROJECT_NAME:
      return {
        ...state,
        project: {
          name: payload,
        },
      };
    case ENABLE_TUNNEL:
      return {
        ...state,
        tunnel: payload,
      };
    case UPDATE_RUNTIME_INFO:
      return {
        ...state,
        runtime: payload,
      };
    case UPDATE_FRAMEWORK:
      return {
        ...state,
        framework: {
          ...state.framework,
          ...payload,
        },
      };
    case UPDATE_MODE:
      return {
        ...state,
        autosplit: payload,
      };
    case UPDATE_RUNS_ON:
      return {
        ...state,
        runson: payload,
      };
    case UPDATE_CONCURRENCY:
      return {
        ...state,
        concurrency: payload,
      };
    case UPDATE_FAILURE_COUNT:
      return {
        ...state,
        maxRetries: payload,
      };
    case TOOGLE_FAILURE:
      return {
        ...state,
        retryOnFailure: payload,
      };
    case UPDATE_JOB_LABEL:
      return {
        ...state,
        jobLabel: payload,
      };
    case UPDATE_PARAMETERS:
      return {
        ...state,
        framework: {
          ...state.framework,
          flags: payload,
        },
      };
    case UPDATE_ENV:
      return {
        ...state,
        env: payload,
      };
    case UPDATE_TEST_DISCOVERY_RESULT:
      return {
        ...state,
        testDiscoveryResultV3: payload,
      };
    case RESET_HYPEREXECUTE_YAML:
      return cloneDeep(initialState);
    case UPDATE_HYP_YAML:
      return {
        ...state,
        [payload?.key]: cloneDeep(payload?.payload),
      };
    case REMOVE_HYP_KEY_YAML:
      return cloneDeep(payload);
    case UPDATE_YAML_COMPOSER:
      return {
        ...payload,
      };
    default:
      return state;
  }
}
